.container {
  display: grid;
  gap: 16px;
}

.copyButtonContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  @media screen and (width >= 769px) {
    flex-direction: row;
    gap: 16px;
    align-items: center;
  }
}
